// extracted by mini-css-extract-plugin
export var animationDuration = "var(--dp_transitions_base_duration_medium2)";
export var hidding = "mt1nVfANUg_hjIg8oVuM";
export var horizontal = "RbMAcsEgFzc3tmSNSR0b";
export var root = "Zvd_1T5YiQ9twkNNr31_";
export var showing = "XN3Rw5hWNIaIkfcu6sdW";
export var snackbar = "x6Tll8XS99byJxJk5lUG";
export var snackbarSlideDown = "MDXdhTGjMHtDjelFC4e9";
export var snackbarSlideUp = "IQ5X81IkO6FxWBPhvkG4";
export var vertical = "bl5I8SXn5fjxjVvuKemR";